import type { InterviewQuestion } from '../../../shared/extractInterviewQuestions';
import { MAX_WARMUPS } from '../../../shared/warmupBank';
import AudienceChip from '../Brief/AudienceChip';
import { useWarmupOpen } from './useWarmupOpen';

export default function WarmupBlock({ slug, questions }: { slug: string; questions: InterviewQuestion[] }) {
  const [open, setOpen] = useWarmupOpen(slug);
  const selected = questions.slice(0, MAX_WARMUPS);
  if (!selected.length) return null;
  return (
    <section aria-label="Warm-up" className="mb-6 border border-line rounded-md bg-card overflow-hidden">
      <button type="button" aria-expanded={open} aria-controls="shoot-warmup-questions" onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-4 text-left">
        <span className="font-semibold text-[16px]">Warm-up</span>
        <span className="font-mono text-[10px] text-faint">{selected.length}</span>
        <span className="ml-auto"><AudienceChip audience="internal" /></span>
        <span aria-hidden className="text-accent text-[17px]">{open ? '⌄' : '›'}</span>
      </button>
      <ol id="shoot-warmup-questions" hidden={!open} className="px-4 pb-4">
        {selected.map((question, index) => (
          <li key={index} className="py-4 border-t border-line-soft">
            <div className="font-mono text-[9px] uppercase tracking-[0.12em] text-faint mb-1.5">W{index + 1}</div>
            <p className="text-[17px] font-medium leading-[1.45]">{question.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
